import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { useFetchApprovalRequests } from '@global/hooks'
import { useApprovalsEnabled } from '@global/hooks/useApprovalsEnabled'
import { Approval } from '@templates/approval'
import { ApprovalContextProvider } from '@templates/approval/contexts'

export const ApprovalsContainer = () => {
  const showApprovalRequests = useApprovalsEnabled()
  const [DATASETS_PAGE_ENABLED = false] = useSelector(
    selectFeatureIncludes([FeatureDict.DATASETS_PAGE]),
  )

  const { approvalRequests, setApprovalRequestsCount, fetchApprovalRequests } =
    useFetchApprovalRequests({ showApprovalRequests })

  if (!showApprovalRequests)
    return <Redirect to={DATASETS_PAGE_ENABLED ? '/' : '/codes/templates'} />

  return (
    <ApprovalContextProvider
      approvalRequests={approvalRequests || null}
      fetchApprovalRequests={fetchApprovalRequests}
      setApprovalRequestsCount={setApprovalRequestsCount}
    >
      <Approval />
    </ApprovalContextProvider>
  )
}
